import { NgModule } from '@angular/core';
import { TimelineComponent } from './timeline.component';
import { MatIconModule } from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { TimelineService } from './timeline.service';
import { PostModule } from '../post/post.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TranslateModule } from '@ngx-translate/core';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { RouterModule } from '@angular/router';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { StoreGridViewModule } from '../../groups/group/store-views/store-grid-view/store-grid-view.module';
import { StoreListViewModule } from '../../groups/group/store-views/store-list-view/store-list-view.module';


@NgModule({
    declarations: [TimelineComponent],
    exports     : [
        TimelineComponent
    ],
    imports: [
        MatIconModule,
        FuseSharedModule,
        MatButtonModule,
        MatTooltipModule,
        MatDividerModule,
        MatFormFieldModule,
        MatInputModule,
        PostModule,
        InfiniteScrollModule,
        TranslateModule,
        IvyCarouselModule,
        RouterModule,
        MatButtonToggleModule,
        StoreListViewModule,
        StoreGridViewModule
    ],
    providers   : [TimelineService]
})
export class TimelineModule
{
}
